import { render } from "./AcceptApplicantSetupPlacement.vue?vue&type=template&id=41d8e15b"
import script from "./AcceptApplicantSetupPlacement.vue?vue&type=script&lang=js"
export * from "./AcceptApplicantSetupPlacement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__